import { useState, useCallback, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'
import { Button } from '../Button'

interface Section {
  name: string
  ref: React.RefObject<HTMLElement>
  label: string
  count?: number
}

interface ProductTabProps {
  sections: Section[]
}

const ProductTabButtons = ({ sections }: ProductTabProps) => {
  const [tabName, setTabName] = useState<string>('detail')
  const [applinkBarHeight, setApplinkBarHeight] = useState<number>(0)

  const scrollToSection = useCallback((ref: React.RefObject<HTMLElement>) => {
    if (ref.current !== null) ref.current.scrollIntoView()
  }, [])

  const handleTabClick = useCallback(
    (name: string, ref: React.RefObject<HTMLElement>) => {
      scrollToSection(ref)
      setTabName(name)
    },
    [scrollToSection]
  )

  // 컴포넌트에서 applink_bar 높이 측정
  useEffect(() => {
    const updateBarHeight = () => {
      const bar = document.querySelector('.applink_bar') as HTMLElement | null
      setApplinkBarHeight(bar ? bar.offsetHeight : 0)
    }

    // 최초 1회 측정
    updateBarHeight()

    // MutationObserver로 applink_bar의 추가/삭제 감지
    const observer = new MutationObserver(updateBarHeight)
    observer.observe(document.body, { childList: true, subtree: true })

    return () => observer.disconnect()
  }, [])

  return (
    <>
      <TabWrap className={`${isMobile ? '' : 'mo_tab'}`} applinkBarHeight={applinkBarHeight}>
        {sections.map((section) => (
          <Tab
            key={section.name}
            className={tabName === section.name ? 'on' : ''}
            onClick={() => handleTabClick(section.name, section.ref)}
          >
            {section.label}
            {section.count !== undefined && <span>{section.count}</span>}
          </Tab>
        ))}
      </TabWrap>
    </>
  )
}

export default ProductTabButtons

export const TabWrap = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'applinkBarHeight',
})<{ applinkBarHeight: number }>`
  position: sticky;
  top: ${({ applinkBarHeight }) => `calc(${applinkBarHeight}px + 59px)`};
  width: 100%;
  display: flex;
  z-index: 20;
  @media screen and (min-width: 768px) {
    position: sticky;
    top: 84px;
    z-index: 10;
  }
`
// 상품 상세정보, 리뷰 탭
export const Tab = styled(Button)`
  flex: 1;
  padding: 15px 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--colGray5);
  background: #fff;

  border-bottom: 1px #eaeaea solid;
  & a {
    color: var(--colGray5);
  }
  & span {
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    color: #007afe;
    margin-left: 3px;
  }
  &.on {
    color: var(--colBlack);
    border-bottom: 1px var(--colBlack) solid;
    & a {
      color: var(--colBlack);
    }
  }
  @media screen and (min-width: 768px) {
    flex: 1;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #898989;
    background: #fff;
    border-bottom: 1px #eaeaea solid;
    & span {
      display: inline-block;
      font-size: 16px;
      font-weight: 500;
      color: #007afe;
      margin-left: 5px;
    }
    &.on {
      color: var(--colBlack);
      border-bottom: 1px var(--colBlack) solid;
    }
  }
`
